// inspired by https://medium.com/@jeremy.w.barbara/how-to-download-a-csv-upon-button-click-in-javascript-e3ae1bae2178

export default {
  mounted() {
    this.handleEvent('direct_download', ({ data, filename, type }) => {
      const csvContent = atob(data)
      const blob = new Blob([csvContent], { type: type })
      const link = document.createElement('a')

      link.href = URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }
}
